import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Receipt, FileText } from "lucide-react";
import { api } from "../../lib/api";
import { useLang } from "../../lib/i18n";
import { money, fmtDate } from "../../lib/helpers";
import { Section, StatusBadge, Empty } from "../common";

export function BillingList({ customerId, projectId, payments }) {
  const { t } = useLang();
  const [docs, setDocs] = useState(null);
  const q = projectId ? `project_id=${projectId}` : `customer_id=${customerId}`;
  useEffect(() => { api.get(`/billing?${q}`).then((r) => setDocs(r.data)).catch(() => setDocs([])); }, [q]);
  const base = `/billing/new?customer=${customerId || ""}${projectId ? `&project=${projectId}` : ""}`;
  return (
    <Section title={t("Invoices & receipts", "Facturas y recibos")} count={docs?.length} testid="billing-list"
      action={<div className="flex gap-1"><Link className="btn-outline btn-sm" to={`${base}&kind=invoice`} data-testid="billing-new-invoice-btn"><FileText className="w-4 h-4" /> {t("Invoice", "Factura")}</Link><Link className="btn-primary btn-sm" to={`${base}&kind=receipt`} data-testid="billing-new-receipt-btn"><Receipt className="w-4 h-4" /> {t("Receipt", "Recibo")}</Link></div>}>
      {docs && !docs.length && <Empty text={t("No invoices or receipts yet", "Aún no hay facturas ni recibos")} testid="billing-list-empty" />}
      {docs?.map((d) => (
        <Link key={d.id} to={`/billing/${d.id}`} className="row-link text-sm" data-testid={`billing-row-${d.id}`}>
          <span className="flex-1 min-w-0"><b>{d.number}</b> · {fmtDate(d.date)}{d.paid_in_full && <span className="ml-2 text-emerald-700 font-semibold">{t("Paid in full", "Pagado")}</span>}</span>
          <span className="mono font-semibold">{money(d.amount)}</span><StatusBadge status={d.status} />
        </Link>
      ))}
      {payments?.length > 0 && (
        <div className="px-4 py-2 border-t text-xs text-slate-600" data-testid="project-payments">
          <div className="font-bold uppercase mb-1">{t("Payment history", "Historial de pagos")}</div>
          {payments.map((p) => <div key={p.id} className="flex justify-between"><span>{fmtDate(p.date)} · {p.method || "—"} · {p.receipt_number}</span><span className="mono">{money(p.amount)}</span></div>)}
        </div>
      )}
    </Section>
  );
}
